/**
 * Haptic feedback utility for mobile devices
 * Uses the Web Vibration API which is supported on most mobile browsers
 */

type HapticType = 'light' | 'medium' | 'heavy' | 'success' | 'error' | 'warning';

const HAPTIC_PATTERNS: Record<HapticType, number | number[]> = {
  light: 10,
  medium: 25,
  heavy: 50,
  success: [10, 50, 20],
  error: [50, 100, 50],
  warning: [30, 50, 30],
};

/**
 * Trigger haptic feedback on supported devices
 * @param type - The type of haptic feedback to trigger
 */
export function triggerHaptic(type: HapticType = 'light'): void {
  // Check if the Vibration API is available
  if (typeof navigator !== 'undefined' && 'vibrate' in navigator) {
    try {
      navigator.vibrate(HAPTIC_PATTERNS[type]);
    } catch (e) {
      // Silently fail if vibration is not allowed
      console.debug('[Haptics] Vibration not available:', e);
    }
  }
}

/**
 * Check if haptic feedback is supported on this device
 */
export function isHapticSupported(): boolean {
  return typeof navigator !== 'undefined' && 'vibrate' in navigator;
}
